module.exports = __webpack_public_path__ + "img/happy-hour-background.cfe0a325.jpg";